import filterAndGroup from "./filterAndGroup";

export function runFilterAndGroup({ tree, ui, filterId, groupById }) {
  const filterPath = ui.filters.find((f) => f.id === filterId)?.path ?? [];

  const depthMap = { group: 0, subgroup: 1, camera: 2 };
  const groupBy = groupById === "uuid" ? "uuid" : { depth: depthMap[groupById] ?? 1 };

  const result = filterAndGroup(tree, { filter: { path: filterPath }, groupBy });

  const uuidToGroupKey = new Map();
  for (const [groupKey, cameraRows] of Object.entries(result.groups)) {
    for (const cam of cameraRows) uuidToGroupKey.set(cam.uuid, groupKey);
  }

  return { ...result, uuidToGroupKey };
}
